module.exports = __webpack_public_path__ + "static/media/tip-5.ae1982fa.mp3";